import { ColDef } from 'ag-grid-community';
import { renderNA, importErrorFunction, generateImportColumn, importTextFormatEditor, formatEditor, generateColumn, setDateFilterDefs } from './../../../../../utils/commonFunctions';
import { dateFormats } from '../../utils/constats';
import { dateFormatter } from '../../../../../config/Global';
import { actionColumn } from '../../../../../utils/commonColumns';

/**
 * Column definitions for listing page
 * cellRenderer to show data as a string
 * valueGetter for getting data from export functionality of ag-grid
 * filterValueGetter for getting data from filter
 * tooltipValueGetter for getting data from tooltip
 * textFormatEditor for getting data from text editor
 */
// nameColumn,
const columnDefs: ColDef[] = [
    {
        ...generateColumn("", "industry_name"),
    },
    {
        ...generateColumn("Exam Status", "exam_status_display"),
    },
    {
        field: "start_date",
        headerName: "Start Date",
        cellRenderer: (props: any) => {
            return props.data.start_time
                ? dateFormatter(props.data.start_time, dateFormats.dob)
                : "N/A";
        },
        filterValueGetter: (props: any) => {
            return props.data.start_time
                ? dateFormatter(props.data.start_time, dateFormats.dob)
                : "N/A";
        },
        valueGetter: (props: any) => {
            return props.data.start_time
                ? dateFormatter(props.data.start_time, dateFormats.dob)
                : "N/A";
        },
        ...setDateFilterDefs()
    },
    { ...actionColumn, width: 130, minWidth: 130 },



];
export default columnDefs;
